export enum enumIncotermApplicableType {
  ALL = 0,
  OCEAN = 1,
}
